import { RepoFactory } from '../../../baseRepository/Factory';
const enumsRepository = () => RepoFactory.get('enums');
import { GET_ENUMS, GET_ENUM_BY_NAME, SET_ALL_ENUMS } from './types';
export const enumsActions = {
  [GET_ENUMS](context, params) {
    return new Promise((resolve, reject) => {
      enumsRepository()
        .getEnums(
          context.getters.tradeBaseUrl,
          {
            MerchantId: context.getters.currentMerchant,
          },
          params
        )
        .then((res) => {
          context.commit(SET_ALL_ENUMS, res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_ENUM_BY_NAME](context, params) {
    return new Promise((resolve, reject) => {
      enumsRepository()
        .getEnum(params.name, context.getters.tradeBaseUrl, {
          MerchantId: context.getters.currentMerchant,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
